import httpManager from "@/app/shared/utils/httpManager";

import { getPaginationQuery } from "@/app/shared/utils/helpers";

export async function fetchTransactions({ filters, page = 1, type = 1 } = {}) {
  const paginationQuery = getPaginationQuery(page);

  const search = filters?.search || "";
  const status = filters?.status || "";
  const startDate = filters?.dateRange?.[0] || "";
  const endDate = filters?.dateRange?.[1] || "";

  const url = `/billing/payments/`;
  const query = `?${paginationQuery}&state=${status}&search=${search}&start_date=${startDate}&end_date=${endDate}&product_type=${type}`;

  const response = await httpManager.get(`${url}${query}`);
  return response.data;
}
